module.exports = __webpack_public_path__ + "img/pro_eight_7.f4d1c5f4.jpg";